// Add the `js-download-with-loader` class to a download link to show a spinner in its `.icon`
// while the file is fetched, and to ignore repeat clicks until it's done.
// Falls back to normal navigation when the server responds with a page (e.g. a redirect with a flash message).

const LINK_SELECTOR = ".js-download-with-loader";
const SPINNER_HTML =
  '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>';

const filenameFromDisposition = (disposition) => {
  if (!disposition) return null;
  const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (encoded) return decodeURIComponent(encoded[1]);
  const plain = disposition.match(/filename="?([^";]+)"?/i);
  return plain ? plain[1] : null;
};

const saveBlob = (blob, filename) => {
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = filename || "";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
};

const downloadWithLoader = async (link) => {
  if (link.getAttribute("aria-busy") === "true") return;

  const url = link.getAttribute("href");
  const icon = link.querySelector(".icon");
  const originalIconHtml = icon ? icon.innerHTML : null;

  link.setAttribute("aria-busy", "true");
  link.classList.add("tw-pointer-events-none", "tw-opacity-50");
  if (icon) icon.innerHTML = SPINNER_HTML;

  try {
    const response = await fetch(url, { credentials: "same-origin" });
    const contentType = response.headers.get("Content-Type") || "";

    if (!response.ok || contentType.includes("text/html")) {
      window.location.href = url;
      return;
    }

    const blob = await response.blob();
    if (blob.size === 0) {
      window.location.href = url;
      return;
    }

    saveBlob(
      blob,
      filenameFromDisposition(response.headers.get("Content-Disposition")) ||
        link.getAttribute("download"),
    );
  } catch (error) {
    window.location.href = url;
  } finally {
    link.removeAttribute("aria-busy");
    link.classList.remove("tw-pointer-events-none", "tw-opacity-50");
    if (icon) icon.innerHTML = originalIconHtml;
  }
};

document.addEventListener("click", (e) => {
  const link = e.target.closest(LINK_SELECTOR);
  if (!link) return;

  const href = link.getAttribute("href");
  if (!href || href === "#") return;

  e.preventDefault();
  downloadWithLoader(link);
});
